import api from "../api/api";

export const addMovementPoint = async (deviceId, lat, lng) => {
    const res = await api.post("/MovementAnalytics/add-point", {
        deviceId: Number(deviceId),
        lat: Number(lat),
        lng: Number(lng),
    });

    return res.data;
};

export const getMovementSpeed = async (deviceId) => {
    const res = await api.get(`/MovementAnalytics/speed/${deviceId}`);
    return res.data;
};

export const getMovementHistory = async (deviceId) => {
    const res = await api.get(`/MovementAnalytics/history/${deviceId}`);
    return res.data;
};